import { z } from 'zod';
import { CommanderOrigin } from '@mews-commander/data-access';

export const OriginFormSchema = z.object({
    origin: z.nativeEnum(CommanderOrigin),
});

export type OriginFormValues = z.infer<typeof OriginFormSchema>;
